<template>
<div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">
    <div class="text-right leading-tight hidden sm:block">
        <p v-if="activeUserInfo.username != 'cogepha'" class="font-semibold">{{ activeUserInfo.displayName }}</p>
        <p v-else class="font-semibold">Cogepha-centre d'appel</p>
        <small>Online</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <div class="con-img ml-3">
            <img key="onlineImg" :src="image" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        </div>

        <vs-dropdown-menu class="vx-navbar-dropdown">
            <ul style="min-width:  11.95rem">
                <div v-if="activeUserInfo.username != 'cogepha'">
                    <li v-if="activeUserInfo.userRole=='SuperAdmin'||activeUserInfo.userRole=='Simple'||activeUserInfo.userRole=='Admin'" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="tosociete()">
                        <img key="onlineImg" :src="imgSociete" alt="user-img" width="18" height="18" class="        " />
                        <span class="ml-2">Société</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="toprofile" v-if="activeUserInfo.userRole != 'GestionnairePortail'">
                        <img key="onlineImg" :src="imgProfile" alt="user-img" width="18" height="18" class="        " />
                        <span class="ml-2">Profil</span>
                    </li>

                    <li v-if="activeUserInfo.userRole=='SuperAdmin'" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="tousers">
                        <img key="onlineImg" :src="imgUsers" alt="user-img" width="18" height="18" class="        " />
                        <span class="ml-2">Utilisateurs</span>
                    </li>
                    <li v-if="activeUserInfo.userRole=='SuperAdmin'||activeUserInfo.userRole=='Simple'||activeUserInfo.userRole=='Admin'" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="tocommandes">
                        <img key="onlineImg" :src="imgTruck" alt="user-img" width="18" height="18" class="        " />
                        <span class="ml-2">Tracking</span>
                    </li>
                </div>
                <vs-divider class="m-1" />

                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                    <img key="onlineImg" :src="imgLogout" alt="user-img" width="18" height="18" class="        " />
                    <span class="ml-2">Se déconnecter</span>
                </li>
            </ul>
        </vs-dropdown-menu>
    </vs-dropdown>
</div>
</template>

<script>
import auth from '@/auth/authService.js'
import socketService from "@/services/SocketService.js";
export default {
    data() {
        return {
            image: require("../../../../../public/profile_default.png"),

            imgSociete: require('@/assets/images/portrait/small/home.png'),
            imgProfile: require('@/assets/images/portrait/small/user6.png'),
            imgUsers: require('@/assets/images/portrait/small/group4.png'),
            imgTruck: require('@/assets/images/portrait/small/truck.png'),
            imgLogout: require('@/assets/images/portrait/small/logout4.png'),
        };
    },
    mounted() {
        const payload = {
            id: this.user_data.id
        };
        this.$store.dispatch("moduleusermanagement/GetImage", payload).then(() => {
            if (this.$store.state.AppActiveUser.image)
                this.image = this.$store.state.AppActiveUser.image;
        });
    },
    created() {
        this.user_data = this.$store.state.AppActiveUser;
        if (this.user_data.image != null) this.image = this.user_data.image;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === "UPDATE_USER_IMAGE")
                this.image = state.AppActiveUser.image;
            if (mutation.type === "UPDATE_USER_INFO")
                this.user_data = state.AppActiveUser;
        });
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        }
    },
    methods: {
        tosociete() {
            // console.log(this.$router.path)
            this.$router.push("/societe");
        },

        tousers() {
            // console.log(this.$router.path)
            this.$router.push("/user/user-list");
        },
        tocommandes() {
            // console.log(this.$router.path)
            this.$router.push("/user/commandes-list");
        },
        toprofile() {
            this.$router.push("/profile");
        },
        logout() {
            // If JWT login
            if (localStorage.getItem("accessToken")) {
                localStorage.removeItem("accessToken");
                localStorage.removeItem("userInfo");
                auth.initRole();
                this.$acl.change("Public");
                this.$router.push("/login");
                this.$store.dispatch("InitStore")
                this.$store.dispatch("auth/logout");
                this.socketDisconnect()

            }

            // Change role on logout. Same value as initialRole of acj.js
            //  this.$acl.change('Public')

            // This is just for demo Purpose. If user clicks on logout -> redirect
        },
        socketDisconnect() {
            socketService.disconnect();
            location.reload();
        }
    }
};
</script>
